import { Alert, Anchor, Box, Group, Paper, ThemeIcon } from '@mantine/core';
import { IconInfoCircle, IconMail } from '@tabler/icons-react';
import { Button, Stack, Text } from '@datavant/dart';
import { SUPPORT_EMAIL } from '../../lib/utils/consts';

interface Props {
    onBack: () => void;
}

export const RmV2SupportView = ({ onBack }: Props): JSX.Element => (
    <Stack gap="lg">
        <Text fw={700} fz="xl">
            Need help with your upgrade?
        </Text>
        <Text size="sm" c="dimmed">
            Our support team can help if your invitation email hasn&apos;t arrived or you&apos;re having
            trouble completing account setup.
        </Text>
        <Paper withBorder={false} bg="var(--mantine-color-gray-0)" p="md" radius="md">
            <Stack gap="sm">
                <Text size="xs" c="dimmed" fw={600} tt="uppercase" lts={0.5}>
                    Contact Support
                </Text>
                <Group gap="sm">
                    <ThemeIcon size={40} radius="md" color="blue">
                        <IconMail size={20} />
                    </ThemeIcon>
                    <Box>
                        <Text size="xs" c="dimmed">
                            Email
                        </Text>
                        <Anchor href={`mailto:${SUPPORT_EMAIL}`} size="sm" fw={700}>
                            {SUPPORT_EMAIL}
                        </Anchor>
                    </Box>
                </Group>
                <Text size="sm" c="dimmed">
                    Include your name and organization in your message so we can locate your account quickly.
                </Text>
            </Stack>
        </Paper>
        <Alert color="blue" variant="light" icon={<IconInfoCircle size={16} />}>
            <Text component="span" size="sm" fw={700}>
                Tip:
            </Text>{' '}
            <Text component="span" size="sm">
                Check your spam or junk folder first &mdash; invitation emails occasionally land there.
            </Text>
        </Alert>
        <Button intent="prominent" fullWidth onClick={onBack}>
            Back
        </Button>
    </Stack>
);
